export enum DashboardType {
  Workbook = 'workbook'
}

export interface Dashboard {
  id: string;
  urlId: string;
  name: string;
  type: DashboardType;
  parentId: string;
  parentUrlId: string;
  permission: string;
  path: string;
  badge?: string;
  ownerId: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  isArchived: boolean;
  description?: string;
}
